/** @typedef {import("../types/feed-post").FeedPostGeneric} FeedPostGeneric */

/**
 * Filter out feed posts from given map
 * @param {Record<string, FeedPostGeneric>} posts
 * @param {(post: FeedPostGeneric) => boolean} postFilter
 *
 */
function filterOutFeedPostsByCondition(posts, postFilter) {
  const postsMap = new Map(Object.entries(posts));

  Object.values(posts).forEach(post => {
    if (postFilter(post)) {
      return;
    }

    postsMap.delete(post.post_id);
  });

  return Object.fromEntries(postsMap.entries());
}

export { filterOutFeedPostsByCondition };
